module.exports = __webpack_public_path__ + "static/media/gas-icon-black.9612eca8.svg";